import React from "react";
import { Card, CardContent, CardHeader } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";
import { cn } from "utils/cn";

const SEARCH_THINKING_CARD_COUNT = 3;
const pulseClass = "bg-border";

const CatalogThinkingCard = () => (
  <Card>
    <CardHeader className="p-[15px]">
      <div className="flex flex-col items-center gap-3 md:flex-row md:items-start">
        <Skeleton className={cn("size-[160px] rounded-full md:hidden", pulseClass)} />
        <Skeleton className={cn("hidden size-[120px] shrink-0 rounded-full md:block", pulseClass)} />
        <div className="flex w-full min-w-0 flex-1 flex-col items-center gap-2 md:items-start">
          <div className="flex w-full flex-col items-center gap-2 md:flex-row md:items-start md:justify-between">
            <div className="flex w-full min-w-0 flex-col items-center gap-1 md:items-start">
              <div className="flex flex-wrap items-center justify-center gap-2 md:justify-start">
                <Skeleton className={cn("h-5 w-36", pulseClass)} />
                <Skeleton className={cn("h-6 w-20 rounded-full", pulseClass)} />
              </div>
              <Skeleton className={cn("h-4 w-32", pulseClass)} />
            </div>
            <div className="flex w-full items-center gap-2 md:w-auto">
              <Skeleton className={cn("size-9 shrink-0 rounded-md", pulseClass)} />
              <Skeleton className={cn("h-9 min-w-0 flex-1 rounded-md md:w-28 md:flex-none", pulseClass)} />
              <Skeleton className={cn("size-9 shrink-0 rounded-md", pulseClass)} />
            </div>
          </div>
        </div>
      </div>
    </CardHeader>
    <CardContent className="flex flex-col gap-3 p-[15px] pt-0">
      <Skeleton className={cn("h-4 w-full", pulseClass)} />
      <Skeleton className={cn("h-3 w-24", pulseClass)} />
      <Skeleton className={cn("h-4 w-4/5", pulseClass)} />
      <div className="flex flex-wrap justify-center gap-2 md:justify-start">
        <Skeleton className={cn("h-6 w-16 rounded-full", pulseClass)} />
        <Skeleton className={cn("h-6 w-24 rounded-full", pulseClass)} />
        <Skeleton className={cn("h-6 w-14 rounded-full", pulseClass)} />
      </div>
    </CardContent>
  </Card>
);

const EventThinkingCard = () => (
  <Card>
    <div className="flex min-w-0 items-start gap-3 p-3">
      <Skeleton className={cn("size-9 shrink-0 rounded-full", pulseClass)} />
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <Skeleton className={cn("h-4 w-40", pulseClass)} />
        <Skeleton className={cn("h-3 w-28", pulseClass)} />
        <Skeleton className={cn("h-5 w-24 rounded-full", pulseClass)} />
        <Skeleton className={cn("h-10 w-full", pulseClass)} />
      </div>
    </div>
  </Card>
);

const SearchThinkingCards = ({ variant = "catalog" }) => (
  <div
    className="flex flex-col gap-3 py-3"
    aria-busy="true"
    data-testid="search-thinking-cards"
    data-variant={variant}
  >
    {Array.from({ length: SEARCH_THINKING_CARD_COUNT }, (_, index) => (
      variant === "event"
        ? <EventThinkingCard key={index} />
        : <CatalogThinkingCard key={index} />
    ))}
  </div>
);

export default SearchThinkingCards;
